import { Injectable } from '@angular/core';

import { ContextMenuOption } from '@gfe/shared/components/context-menu/context-menu.component';

export interface ContextMenuHeader {
  entityType: string;
  name: string;
}

@Injectable({
  providedIn: 'root'
})
export class ContextMenuService {
  private handlers = new Map<string, (target: HTMLElement) => ContextMenuOption[]>();
  private headers = new Map<string, (target: HTMLElement) => ContextMenuHeader | null>();

  register(
    type: string,
    handler: (target: HTMLElement) => ContextMenuOption[],
    header?: (target: HTMLElement) => ContextMenuHeader | null
  ) {
    this.handlers.set(type, handler);
    if (header) {
      this.headers.set(type, header);
    } else {
      // Re-registering a type without a header must not keep the old one.
      this.headers.delete(type);
    }
  }

  unregister(type: string) {
    this.handlers.delete(type);
    this.headers.delete(type);
  }

  getOptions(target: HTMLElement): ContextMenuOption[] {
    const type = target.getAttribute('data-context');
    if (type && this.handlers.has(type)) {
      return this.handlers.get(type)!(target);
    }
    return [];
  }

  getHeader(target: HTMLElement): ContextMenuHeader | null {
    const type = target.getAttribute('data-context');
    return (type && this.headers.get(type)?.(target)) || null;
  }
}
